package com.shadowings.gero.data.lessons.chapter13

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_1
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_2
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_3
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_4
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_5
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_6
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_7
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_8
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_9
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_10
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_11
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_12
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_13
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_14
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_15
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_16
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_17
import gero.composeapp.generated.resources.exp_content_la_frase_misteriosa_18
import gero.composeapp.generated.resources.exp_title_la_frase_misteriosa

private const val FIRST_CLAUSE_GARDINER = "M17-G43-A1-D2h2:Z1-G17-D36:N29-M36:D21-Q3w0.5-G40-X1:N9:Z2"

fun getLaFraseMisteriosaContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_2,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_3,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_4,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_6,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_8,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(modifier = Modifier.fillMaxWidth(), contentAlignment = Alignment.Center) {
                    MdCWord(word = FIRST_CLAUSE_GARDINER, rtl = false, cart = false, size = 56.dp)
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_9,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_10,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_12,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_13,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_15,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_16,
            face = Faces.Serious,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_17,
            face = Faces.Doubt,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_la_frase_misteriosa,
            content = Res.string.exp_content_la_frase_misteriosa_18,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

fun getLaFraseMisteriosaQuizContent(
    hiero: List<Hiero>,
    verbs: List<Verb>,
    words: List<Word>,
    languageCode: String,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val quiz1 = getLePreposizioniQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
    val quiz2 = getPreposizioneHrQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
    val quiz3 = getPreposizioneMLocativaQuizContent(verbs, words, languageCode, verbSentences = verbSentences)
    val quiz4 = getParoleDelTempoQuizContent(hiero, words, languageCode)
    val quiz5 = getPreposizioneDrQuizContent(verbs, words, languageCode, verbSentences = verbSentences)

    val allQuizzes = quiz1 + quiz2 + quiz3 + quiz4 + quiz5
    return allQuizzes.shuffled().take(10)
}
